import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { RobotoTypography } from "@/shared/components/RobotoTypography";
import { AgentThreadErrorContent } from "@/shared/domain/agentThread/AgentThreadRecord";

import styles from "./AssistantErrorContent.module.css";

interface AssistantErrorContentProps {
  error: AgentThreadErrorContent;
}

/**
 * Component for rendering error content in thread messages.
 * Displays an error icon and user-friendly error message.
 */
export const AssistantErrorContent = ({
  error,
}: AssistantErrorContentProps) => {
  return (
    <div className={styles.indentedContainer}>
      <div className={styles.messageContainer}>
        <ErrorOutlineIcon className={styles.errorIcon} />
        <RobotoTypography className={styles.text}>
          {error.error_message}
        </RobotoTypography>
      </div>
    </div>
  );
};
